import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

import { getAccessToken } from 'Components/KeycloakWrapper';
import { isOfflineMode } from 'Utils/isOfflineMode.utils';
import packageJson from '../../../../package.json';

let client: AxiosInstance | null = null;

export async function getStbClient(): Promise<AxiosInstance> {
  if (client == null) {
    const baseURL = await getBaseUrl();
    client = axios.create({
      baseURL,
      headers: { ClientId: packageJson.name },
    });
    registerInterceptors(client);
  }
  return client;
}

async function getBaseUrl(): Promise<string> {
  if (isOfflineMode()) {
    return 'https://api-t.storebrand.no';
  }
  const response = await axios.get<{ apihome: string }>('/api.json');
  return response.data.apihome;
}

function registerInterceptors(instance: AxiosInstance): void {
  instance.interceptors.request.use(automaticallyAuthorizedRequests);
}

async function automaticallyAuthorizedRequests(
  config: InternalAxiosRequestConfig,
): Promise<InternalAxiosRequestConfig> {
  if (config.url?.includes('/open/') ?? true) {
    return config;
  }
  const token = await getAccessToken();
  config.headers.set('Authorization', `Bearer ${token}`);
  return {
    ...config,
  };
}
